import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const TitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    span {
        flex: 1 1 auto;
        min-width: 0;
    }
`;

export const Controls = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const Chips = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

/*
* Высота фиксирована, а прокрутка своя: диалог не должен менять размер, пока пользователь
* убирает позиции одну за другой — строки остаются на месте, и список бы «дышал».
* На узком вьюпорте диалог разворачивается на весь экран, и та же фиксированная высота
* оставила бы под списком пустой экран — там он растягивается на всё, что осталось.
* */
export const List = styled.div`
    height: 372px;
    overflow-y: auto;
    margin: 0 -24px -8px;
    border-top: 1px solid ${colors.borderSofter};

    @media (max-width: 599px) {
        height: auto;
        flex: 1 1 auto;
        min-height: 0;
    }
`;

export const Row = styled.div<{ $justAdded: boolean }>`
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 12px 24px;
    border-bottom: 1px solid ${colors.borderSofter};
    background: ${({ $justAdded }) => ($justAdded ? colors.dangerHover : "transparent")};

    > div:first-child {
        flex: 1 1 auto;
        min-width: 0;
    }

    button {
        flex: none;
    }
`;

export const Name = styled.div<{ $justAdded: boolean }>`
    font-size: 15px;
    font-weight: 600;
    color: ${({ $justAdded }) => ($justAdded ? colors.textSecondary : colors.textPrimary)};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Meta = styled.div`
    margin-top: 2px;
    font-size: 12px;
    color: ${colors.textSecondary};
`;

export const Empty = styled.div`
    padding: 24px;
    text-align: center;
    font-size: 14px;
    color: ${colors.textSecondary};
`;

export const LoadMoreAnchor = styled.div`
    height: 1px;
`;

export const Footer = styled.div`
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const Hint = styled.div`
    flex: 1 1 auto;
    font-size: 13px;
    color: ${colors.textSecondary};
`;
